<div class="meter-header-icon">
  <div *ngIf="showTooltip" class="icon-tooltip">
    {{ tooltipText | translate }}
  </div>

  <app-svg-icon class="icon" (mouseover)="showTooltip = true" (mouseout)="showTooltip = false" [src]="srcSvg"> </app-svg-icon>

  <div *ngIf="badgeText" class="icon-badge">
    {{ badgeText }}
  </div>
</div>
